<ng-template #modalContainer let-data>
  <div class="cg-dialog">
    <h3 class="cg-dialog__header cg-dialog__header--modal">
      {{ data.header }}
      <button
        cignaButton="link inline no-underline"
        class="cg-dialog__close_new"
        (click)="closeDialog()"
      >
        Close
        <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
      </button>
    </h3>
    <div class="cg-dialog__body" [innerHTML]="data.body"></div>
  </div>
</ng-template>
